import { geoEquirectangular, geoPath, type GeoSphere } from 'd3-geo';
import type { FeatureCollection, Geometry } from 'geojson';
import isoCountries from 'i18n-iso-countries';
import { feature } from 'topojson-client';
import type { GeometryCollection, Topology } from 'topojson-specification';
import worldTopologyJson from 'world-atlas/countries-110m.json';

export const WORLD_MAP_WIDTH = 1_000;
export const WORLD_MAP_HEIGHT = 500;
const mapPadding = 1;
const sphere: GeoSphere = { type: 'Sphere' };

const topology = worldTopologyJson as unknown as Topology<{ countries: GeometryCollection<{ name: string }> }>;
const worldFeatures = feature(topology, topology.objects.countries) as unknown as FeatureCollection<Geometry>;

export function createWorldMapSvg(): string {
  const projection = geoEquirectangular().fitExtent(
    [[mapPadding, mapPadding], [WORLD_MAP_WIDTH - mapPadding, WORLD_MAP_HEIGHT - mapPadding]],
    sphere,
  );
  const pathGenerator = geoPath(projection);
  const paths = worldFeatures.features.map((country) => {
    const numericCode = String(country.id ?? '').padStart(3, '0');
    const alpha2 = isoCountries.numericToAlpha2(numericCode);
    const regionName = alpha2 ?? `MAP-${numericCode}`;
    const pathData = pathGenerator(country);
    return pathData === null ? '' : `<path name="${regionName}" d="${pathData}"/>`;
  });

  return `<svg xmlns="http://www.w3.org/2000/svg" width="${WORLD_MAP_WIDTH}" height="${WORLD_MAP_HEIGHT}" viewBox="0 0 ${WORLD_MAP_WIDTH} ${WORLD_MAP_HEIGHT}">${paths.join('')}</svg>`;
}
